export default {
  company: {
    name: '华馥科技'
  },
  meun: {
    home: '首页',
    meterReader: '远程无线抄表',
    gateway: '光伏四可网关',
    AIgateway: 'AI通讯网关',
    carbonNeutralityCloud: '碳和云平台',
    photovoltaic: '光储充',
    energyManagement: '零碳工厂',
    buyAndSellElectricity: '购售电',
    operationsAndMaintenance: '电力运维',
    operationsAndMaintenanceM: '运维',
    aboutUs: '走进华馥',
    aboutM: '华馥',
    news: '新闻动态',
    products: '产品',
    solution: '解决方案',
    login: '碳和云平台'
  },
  solution: {
    title: '解决方案',
    content1:
      '光伏智慧能源系统分为光伏营帐系统和光伏运维系统，营帐系统主要用于信息采集、设备通信以及对电表数据进行统计分析等，而运维平台则是作用于故障告警检测及推送、满发小时数预警分析、智能巡检和清洗。两个系统相辅相成，提供优质全面的系统服务，让电站运营更加智能化。'
  },
  product: {
    title: '产品中心',
    tab1: '光伏智能运维平台',
    tab2: '光伏智能营帐平台',
    IOMP: {
      title1: '光伏智能管家',
      cont1:
        '光伏智能管家，可以随时随地掌握到每一个电站的信息，了解其发电功率、发电量、告警状态等信息。做到组件级监控，通过相关电流电压等数据分析，确认故障原因，精准快速定位运维。降低了后期运维成本，大大提高运维便捷度。',
      title2: '核心技术',
      cont2: {
        p1: '1. 集成清洗无人机飞控平台和视频，实时高效清洗光伏电站面板',
        p2: '2. 集成市电来电和断电检测功能，实时检测市电状态',
        p3: '3. 集成光伏高清摄像头，通过AI技术识别光伏电站防侵入等场景',
        p4: '4. 基于CentOS仿真平台和大数据分析模型，生成光伏电站的组串数据，并对每组数据进行检测生成组串分析报告'
      },
      cont3: {
        p1: '电站管理',
        p2: '在线监测',
        p3: '交流侧管理',
        p4: '视频监控',
        p5: '逆变器管理',
        p6: '告警管理',
        p7: '电站健康度',
        p8: '电站满发小时数',
        p9: '组串IV诊断',
        p10: '光伏面板清洗'
      }
    },
    IBMP: {
      title1: '光伏营帐系统',
      cont1:
        '光伏营帐系统，采用AI智能、物联网技术管理软件系统，基于传感器硬件和红外抄表终端，实现光伏电站设备自动抄表和健康维护的功能，解决企业在光伏电站运维中收费难、成本高等痛点',
      title2: '平台价值',
      cont2: '平台的使用提升了交易效率，降低了技术门槛，平滑了用户体验，确保了储能安全',
      cont3: '解决企业以下三大痛点',
      p1: '电站量多，抄表成本增加',
      p2: '账单混乱，回款周期拉长',
      p3: '数据延迟，异常无法获取'
    }
  },
  news: {
    title: '新闻动态',
    cont: {
      title1: '2024年持续推广分布式光伏',
      cont1:
        '国网徐州供电公司“领航者”低空作业无人机系统技术品牌发布会在徐州启幕,相关负责人参加发布会。“领航者”是徐州供电公司依托产业单位徐电集团自主研发的无人机品牌，自2019年第一代面世以来，目前已完成第五代升级。',
      title2: '国家能源局：加快构建新型能源体系',
      cont2: '国家能源局3月24日消息，近日，第七届中国-欧佩克高级别对话会在奥地利维也纳举行。',
      title3: '国网山西省电力公司超高压输电完成无人机集群作业',
      cont3:
        '5月9日，记者从国网山西省电力公司了解到，在500千伏热原线巡视现场，随着3架无人机集群作业完成平稳落地，国网山西超高压输电公司首次无人机集群化作业成功完成。',
      title4: '中国电科院电力物联网关键技术项目取得突破',
      cont4:
        '近日从中国电力科学研究院获悉，该院自主攻关的电力物联网关键技术及智能应用项目取得突破性进展，目前已在天津滨海电力物联网示范工程试运行半年以上，相关研究课题完成了绩效考核评价。'
    }
  },
  aboutUs: {
    title: '关于我们',
    title1: '公司简介',
    cont1: {
      p1: '深圳市华馥科技公司成立于2024年，针对新能源行业提供平台系统开发和综合解决方案。华馥科技拥有行业傲人的技术研发团队，从设计咨询，集成开发，平台运营以及运维到平台上线开发应用，随时为客户提供最新，最快的技术服务和支持。',
      p2: '拥有自主研发的BIPV光伏能源监测运维管理系统、建筑碳排放监测管理系统、AIoT生态摄像机系统及传感器技术，面向建筑碳排放及新能源光伏行业提供监测运维管理系统、物联网软硬件研发解决方案。',
      p3: '产品包括光伏电站智慧监测运维系统、碳排放监测技术、建筑光伏自动化清洁系统、设备监测控制管理平台及物联网设备传感器等。系统通过实时采集光伏控制器、逆变器及储能装置等的并离网发电运行数据，监测BIPV建筑的光伏发电太阳总辐射、太阳光照度、光伏板灰尘密度等，控制喷淋清洁设备等，实现新能源项目的光伏发电预测、远程预警维护和管理分析。一步一个脚印，努力践行智慧新能源系统与光伏建筑一体化应用。',
      p4: '华馥科技以技术为依托，应用现代化的信息管理系统，凭借创新的研发、优质的产品、高效的服务为客户提供完善可靠的合作平台。秉持“为客户创造价值，与员工分享价值，为社会奉献价值”的价值观，华馥科技愿继续致力于打造更安全、更高效、更智慧的电气应用解决方案。'
    },
    title2: '企业文化',
    cont2: {
      p1: '使命',
      p2: '愿景',
      p3: '定位',
      p4: '目标',
      p5: '价值观'
    },
    cont3: {
      title1: '创造绿色新视界',
      title2: '诚信、创新、竞争',
      title3: '综合能源服务平台',
      title4: '社会贡献大的行业开拓者',
      title5: '创新 高效 诚信 共赢',
      intro1: '节能减排，无噪声，无污染',
      intro2: '科技创新、规范管理、强化品质、诚信经营、优质服务，生产世界一流产品。',
      intro3:
        '主营工商业光伏、微电网、储能以及分布式太阳能发电智能运维等为一体的绿色综合能源服务平台',
      intro4: '企业大而强，员工富而乐，上下同心，筑就伟业。',
      intro5:
        '华馥科技核心价值观包括“创新、高效、诚信、共赢”，这四个词既是企业建设中的重要元素，也是企业在市场竞争中不断前进的助推器'
    },
    title3: '核心竞争力',
    cont4: {
      title1: '精英团队',
      title2: '自主品牌',
      title3: '战略合作',
      intro1: '全球领先的行业专家及专业的研发团队',
      intro2: '拥有十几个自主品牌,角度思考角度看',
      intro3: '与全球运营商和行业客户形成战略合作'
    },
    title4: '公司地址'
  },
  home: {
    profile1:
      '深圳市华馥科技有限公司成立于2024年，是一家工商业光伏集成式开发，整合，管理，运维的高新技术公司。主营工商业光伏、微电网、储能以及分布式太阳能发电智能运维等为一体的绿色综合能源服务平台，公司自主研发的工商业光伏智能管理平台，达到组件级监测功能和运维功能。',
    profile2:
      '公司拥有资深软硬件工程师技术团队，成为广东省工商业光伏运维的最佳综合智能管理运营平台，同时也为全国各大工商业光伏企业提供了最为保障的运营服务中心。现有国内几百家电站同时上线运营，年监控发电量200GWh；成为新能源管理行业的标杆！',
    button1: '了解更多+',
    product: '产品中心',
    solution: '解决方案',
    button2: '查看更多',
    news: {
      title1: '2024年持续推广分布式光伏',
      title2: '国家能源局：加快构建新型能源体系',
      title3: '国网山西省电力公司超高压输电完成无人机集群作业',
      title4: '中国电科院电力物联网关键技术项目取得突破',
      intro1:
        '国网徐州供电公司“领航者”低空作业无人机系统技术品牌发布会在徐州启幕,相关负责人参加发布会。“领航者”是徐州供电公司依托产业单位徐电集团自主研发的无人机品牌，自2019年第一代面世以来，目前已完成第五代升级。发布会上，徐电集团携“领航者”系列产品亮相，首次向社会发布“领航者”低空作业无人机系统技术品牌，全景化展示型谱规划完整、系统高度自主的智能无人机产品，体现了徐电集团无人机非凡研发历程与行业过硬技术实力。',
      intro2: '国家能源局3月24日消息，近日，第七届中国-欧佩克高级别对话会在奥地利维也纳举行。',
      intro3:
        '5月9日，记者从国网山西省电力公司了解到，在500千伏热原线巡视现场，随着3架无人机集群作业完成平稳落地，国网山西超高压输电公司首次无人机集群化作业成功完成。',
      intro4:
        '近日从中国电力科学研究院获悉，该院自主攻关的电力物联网关键技术及智能应用项目取得突破性进展，目前已在天津滨海电力物联网示范工程试运行半年以上，相关研究课题完成了绩效考核评价。'
    }
  },
  photovoltaic: {
    introduce:
      '精灵是一款智能电表的红外采集设备，体积很小，重量只有20克，集成红外/蓝牙/4G通信，内置电池可连续工作5年，支持OTA远程配置升级，支持DL/T 645、DL/T 698和DLMS/COSEM电表协议，兼容中国和东南亚地区的全部电表，提供标准MQTT和API接口，无缝与第三方平台对接，已广泛应用于中国和东南亚地区新能源和传统电力市场的电表采集场景。',

    introduce2:
      '历经5年自主研发的光储充管理平台，基于AI大数据架构，包含客户端展示、电站智能拓扑、运行状态综合监控等多维度服务。帮助用户提高电站生产效率，降低能源消耗水平，提高企业的经济效益。'
  },
  energyManagement: {
    introduce:
      '部署在企业/工厂的各个馈电箱的电表处，每1/5/15分钟高频采集用电企业/工厂/车间各个节点的用电量，包括总表和分表用电数据，平台系统通过AI算法处理生成用电量分析报表，汇总生成日/月/年的用电负载曲线报告，并给出节能用电方案，帮助企业达到节能减排目标。',

    introduce2:
      '帮助企业进行用电能耗管理，通过“精灵”每1/5/15分钟高频采集用电企业/工厂/车间各个节点的用电量，包括总表和分表用电数据，平台系统通过AI算法处理生成用电量分析报表，汇总生成日/月/年的用电负载曲线报告，并给出节能用电方案，帮助企业达到节能减排目标。'
  },
  buyAndSellElectricity: {
    introduce:
      '部署在用电企业的各个用电节点的电表处，满足各个地区电力交易中心平台需求，可实现每15分钟高频采集电站的发电量和用户侧的用电量数据，自动以96/天的频率给各个地区电力交易中心平台上报实时电价和实时用电量数据。',

    introduce2:
      '通过“精灵”每1/5/15分钟高频采集电站的发电量和用户侧的用电量数据，结合AI算法进行数据清洗/分类/整理，进行实时电价和实时用电量计算，并预测下一阶段的电价和电量，自动生成实时电价和实时电量数据，自动送到各个地市的电力交易中心平台进行报价和保量辅助交易。'
  },
  operationsAndMaintenance: {
    introduce:
      '对新能源电站进行集中监控，结合电站设备运行状态进行自动检测，针对光伏储能发电系统特点和并网运行数据进行系统运行安全管理、运维管理和收费管理，运维团队可根据碳和云平台给出的电站运行结论制定运行规程、检修维护规程、巡视检查规程、应急管理和事故分级处理等响应措施和工作指导,为新能源电站提供信息化管理，利用数字化信息化技术，实现光伏储能充电桩站点的数据共享和远程监控的AI智能化运维服务。',
    introduce2:
      '通过“精灵”每1/5/15分钟高频采集电站的发电量和用户侧的用电量数据，结合AI算法进行数据清洗/分类/整理，进行实时电价和实时用电量计算，并预测下一阶段的电价和电量，自动生成实时电价和实时电量数据，自动送到各个地市的电力交易中心平台进行报价和保量辅助交易。',
    introduc3:
      '华馥电力运维主要提供光伏电站组件维护保养、电气设备巡检和故障检修等一系列内容，目前业务覆盖广东、广西、上海和江苏等省市地区，服务全国一百多家企业客户，运维管理3500多个光伏电站。',
    introduc4:
      ' 华馥运维基于自研的运维平台和硬件设备，包括光伏电站管理云平台-碳和云、逆变器的采集设备、四可网关和二次电气设备、远程红外电表采集器-精灵、气象站等一系列运维工具。',
    introduc5:
      '华馥碳和云运维平台采用AI智能管理软件系统和物联网技术，兼容市面全部逆变器接口，无缝实时采集各逆变器告警和运行数据，AI智能化诊断电站运行状态，自动将电站告警生成工单并实时派送，实现光伏电站设备集中监控和健康维护，解决新能源电站分散造成管理难、运维难、成本高痛点。'
  },
  footer: {
    cont1: '深圳市华馥科技有限公司，工商业光伏集成式开发，整合，管理，运维的高新技术公司',
    title2: '联系我们',
    address: '深圳市宝安区旭生大厦',
    title3: '工作时间',
    cont3: '周一至周五'
  }
}
